import React, { Component } from "react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { setCookie, CookieName } from "../../utils/cookieManager";
import Snackbar from "@material-ui/core/Snackbar";
import { Config } from "../../utils/Config";

import ReactGA from "react-ga";
ReactGA.initialize("UA-42096921-3");

class OtpScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      otp: "",
      isSnackBarOpen: false
    };
    this.openSnackBar = this.openSnackBar.bind(this);
  }

  componentDidMount() {}

  handleChange = name => event => {
    if (name === "otp") {
      this.setState({ otp: event.target.value });
    }
  };

  openSnackBar = message => {
    const msg = (
      <div className="snackbar-msg" id="message-id">
        {message}
      </div>
    );
    this.setState({ isSnackBarOpen: true, message: msg });
  };

  handleClose = () => {
    this.setState({ isSnackBarOpen: false });
  };

  login = () => {
    if (!this.state.otp) {
      this.openSnackBar("Please enter OTP");
      return;
    }
    const loginUrl = `${Config.SECURED_API_HOST}/api/platform/authenticatenew?mobileNumber=${this.props.mobileNumber}&otp=${this.state.otp}`;

    fetch(loginUrl)
      .then(res => res.json())
      .then(res => {
        if (res) {
          setCookie(CookieName.USERTOKEN, res.authToken, 60);
          setCookie(CookieName.USERTEMPTOKEN, res.tempToken, 60);
          setCookie(CookieName.LOGINTYPE, CookieName.OTP, 60);
          ReactGA.event({
            category: "login",
            action: "login-otp-verified-success"
          });
          return res;
        } else {
          return Promise.reject("Could not verify OTP");
        }
      })
      .then(res => {
        if (res) {
          if (this.props.isNewUser === true) {
            const updateUserUrl = `${Config.SECURED_API_HOST}/api/platform/UpdateUser`;
            fetch(updateUserUrl, {
              method: "post",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                userKey: res.authToken,
                PhoneNumber: this.props.mobileNumber
              })
            });
          }
          const userDetailsUrl = `${Config.SECURED_API_HOST}/api/platform/userdetails?authToken=${res.authToken}`;
          return fetch(userDetailsUrl);
        }
      })
      .then(res => res.json())
      .then(res => {
        if (res) {
          setCookie(CookieName.USERNAME, res.Name, 60);
          setCookie(CookieName.USEREMAIL, res.Email, 60);
          setCookie(CookieName.USERIMG, res.ProfileImage, 60);
          if (res.PhoneNumber) {
            setCookie(CookieName.USERMOBILE, res.PhoneNumber, 60);
          } else {
            setCookie(CookieName.USERMOBILE, this.props.mobileNumber, 60);
          }
          this.props.history.replace(this.props.defaultPath);
        } else {
          this.openSnackBar("Could not verify OTP");
        }
      })
      .catch(error => {
        this.openSnackBar(error);
        console.log(error);
      });
  };

  render() {
    const loginContainerStyle = {
      padding: "14px"
    };

    const inputbxStyle = {
      width: "100%"
    };

    const btnOtpStyle = {
      padding: "14px 16px"
    };

    const title = (
      <div className="title-img-center">
        <img
          src="https://www.confirmtkt.com/img/horizontal.png"
          alt="confirmtkt_logo"
          height="40"
        />
        <br />
        <div id="">LOG IN/SIGN UP</div>
      </div>
    );

    const otpFlow = (
      <div className="otp">
        <span>Mobile Number</span>
        <br />
        <span>+91{this.props.mobileNumber}</span>

        <TextField
          label="Enter OTP"
          id="OTP"
          type="number"
          style={inputbxStyle}
          onChange={this.handleChange("otp")}
        />
        <br />
        <br />
        <Button
          variant="contained"
          className="ctkt-btn-success zero-border-radius"
          style={btnOtpStyle}
          onClick={this.login}
        >
          SUBMIT OTP
        </Button>
      </div>
    );

    return (
      <div className="otp-screen text-align-center" style={loginContainerStyle}>
        {title}
        {otpFlow}

        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          open={this.state.isSnackBarOpen}
          onClose={this.handleClose}
          ContentProps={{
            "aria-describedby": "message-id"
          }}
          autoHideDuration={10000}
          message={this.state.message}
        />
      </div>
    );
  }
}

export default OtpScreen;
